import styled from "styled-components";
import { useSelector } from "react-redux";
import FakeCardSubmit from "./FakeCardSubmit";
import FakeCardUserBlock from "./FakeCardUserBlock";

const FakeCardPage = () => {
  const {
    fakeCard: { fakeCardUsers, submitLogList, turnStep },
  } = useSelector(state => state.GameSlice);

  const kindColors = {
    map: "red",
    ceramic: "blue",
    compass: "yellow",
    coin: "green",
    machete: "orange",
    canteen: "purple",
  };

  return (
    <Wrap>
      <GameContainer>
        <PlayerContainer>
          {fakeCardUsers?.map(i => (
            <FakeCardUserBlock key={`${i.userId}fakeCardUser`} user={i} />
          ))}
        </PlayerContainer>
        <LogContainer>
          {submitLogList.map((item, index) => {
            const cards = item?.items;
            return (
              <LogBox key={`${index}logBoxKeys`}>
                {cards?.map((secondItem, secondIndex) => {
                  const cardColor =
                    turnStep === 4 ? kindColors[secondItem?.label] : "#d9d9d9";
                  return (
                    <LogCard
                      key={`${index}logCardKey${secondIndex}`}
                      style={{ backgroundColor: cardColor }}
                    />
                  );
                })}
              </LogBox>
            );
          })}
        </LogContainer>
      </GameContainer>
      <FakeCardSubmit />
    </Wrap>
  );
};

const Wrap = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  border-left: 1px solid #e0e0e0;
  justify-content: space-between;
`;

const GameContainer = styled.div`
  width: 100%;
  display: flex;
  flex-grow: 1;
`;

const PlayerContainer = styled.div`
  display: flex;
  width: 60%;
  height: 100%;
  flex-direction: column;
`;
const LogContainer = styled.div`
  display: flex;
  width: 40%;
  height: 100%;
  overflow-y: auto;
  gap: 10px;
  flex-direction: column;
  padding: 5px 10px;
`;

const LogBox = styled.div`
  width: 100%;
  border: 1px solid #d9d9d9;
  padding: 20px 10px 10px;
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
`;

const LogCard = styled.div`
  width: 20px;
  height: 20px;
`;

export default FakeCardPage;
